import {getValueByDevice, useDevice} from 'platform/foundation';

export const useHeaderHeight = () => {
  const device = useDevice();
  return getValueByDevice(device, 96, 48, 48, 48);
};
